import api from "../axios";
import type { UserSubscription } from "../types";

export interface SubscriptionsResponse {
  data: UserSubscription[];
}

export const subscriptionsApi = {
  baseKey: ["subscriptions"],

  getSubscriptionsQueryOptions: () => {
    const queryKey = [...subscriptionsApi.baseKey, "list"];

    return {
      queryKey,
      queryFn: async ({
        signal,
      }: {
        signal?: AbortSignal;
      }): Promise<UserSubscription[]> => {
        const response = await api.get<UserSubscription[]>("/tables", {
          signal,
        });
        return response.data;
      },
    };
  },
};
